// extracted by mini-css-extract-plugin
module.exports = {"grid1":"fs_grid1__24UKy","previewCard":"fs_previewCard__3ZB0Z","labelc1":"fs_labelc1__1I4Ud","previewHead":"fs_previewHead__z-SP5"};